import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { reducers } from 'src/redux';
import App from 'src/App';

ReactDOM.render(
  <Provider store={reducers.store}>
    <PersistGate loading={null} persistor={reducers.persist}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
